import errorMessages from '@common/constants/errorMessages';
import { isEmpty, validatePhoneNumber, validEmailAddress } from '@common/paymentsUtils/inputValidator';

const isEmailAddressValid = (emailAddress) => {
  if (isEmpty(emailAddress)) {
    return errorMessages.EMAIL_ADDRESS_EMPTY;
  } else if (!validEmailAddress(emailAddress)) {
    return errorMessages.INVALID_EMAIL_ADDRESS;
  }
  return errorMessages.CLEAR_ERROR;
};

function isPhoneNumberValid(phoneNumber) {
  if (!validatePhoneNumber(phoneNumber)) {
    return errorMessages.PHONE_NUMBER_INVALID;
  }
  return errorMessages.CLEAR_ERROR;
}

export function validateAllInputs(emailAddress, phoneNumber) {
  const errors = {
    hasErrors: false,
    emailAddressError: '',
    phoneNumberError: '',
  };
  const emailAddressError = isEmailAddressValid(emailAddress);
  const phoneNumberError = isPhoneNumberValid(phoneNumber);

  if (emailAddressError || phoneNumberError) {
    errors.hasErrors = true;
  }

  if (emailAddressError) {
    errors.emailAddressError = emailAddressError;
  }

  if (phoneNumberError) {
    errors.phoneNumberError = phoneNumberError;
  }

  return errors;
}
